// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"606":"e5e8e75a","882":"a5ba5984"}[chunkId] + ".js";
};